module.exports = __webpack_public_path__ + "img/14.a5257627.png";